import * as types from './mutation-types'
import {default as auth, namespace as authNamespace} from './modules/auth'
import {default as pages, namespace as pageNamespace} from './modules/pages'
import {default as giftcard, namespace as giftcardNamespace} from './modules/giftcard'
import {default as profile, namespace as profileNamespace} from './modules/profile'
import {default as race, namespace as raceNamespace} from './modules/race'
import createPersistedState from 'vuex-persistedstate'

// set this true to namespace all getters, mutations, actions etc.
const namespaced = true
const namespace = 'RacewayBooking'

const modules = {
  [authNamespace]: auth,
  [pageNamespace]: pages,
  [giftcardNamespace]: giftcard,
  [profileNamespace]: profile,
  [raceNamespace]: race,
}

// state
const state = {
  timeslotTabs: {
    'day': {start: '', end: '16.59'},
    'evening': {start: '17:00', end: ''}
  },
  maxKarts: 12
}
const helpers = {}

// mutations
const mutations = {}

const actions = {}

// getters
const getters = {
  timeslotTabs: state => state.timeslotTabs,
  maxKarts: state => state.maxKarts
}

// plugins
const plugins = [
  createPersistedState({
    paths: [
      `${namespace}.${authNamespace}`,
      `${namespace}.${raceNamespace}.editItem`,
      `${namespace}.${raceNamespace}.cartItems`,
      `${namespace}.${giftcardNamespace}.editItem`,
      `${namespace}.${giftcardNamespace}.cartItems`,
      `${namespace}.${pageNamespace}.postLoginPage`
    ],
    key: namespace,
  }),
]

export {namespaced, namespace, state, mutations, actions, getters, plugins, modules}
